
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchProductBaseFormats } from './fetch-product-base-formats';

/**
 * `Props` type.
 */

type Props<P> = QueryObserverBaseResult<P, unknown>;

/**
 * `Options` type.
 */

type Options<P> = {
  enabled?: boolean,
  initialData?: P | null
};

/**
 * Action type.
 */

const actionType = 'product-base-formats';

/**
 * `useProductBaseFormats` hook.
 */

function useProductBaseFormats<P>(options?: Options<P>): Props<P> {
  const result = useQuery([actionType], () => {
    return fetchProductBaseFormats();
  }, {
    enabled: options?.enabled,
    initialData: options?.initialData
  });

  return result;
}

/**
 * Export `useProductBaseFormats` hook.
 */

export default useProductBaseFormats;
